import type { ActKc2TotalItem } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useMemo } from 'react';

export const useUerActKC2TotalsColumns = () =>
    useMemo<ColDef<ActKc2TotalItem>[] | ColGroupDef<ActKc2TotalItem>[]>(
        () => [
            {
                headerName: 'Наименование работ',
                field: 'name',
                flex: 1,
            },

            {
                headerName: 'Выполнено работ',
                width: 180,
                children: [
                    {
                        headerName: 'Стоимость, руб.',
                        field: 'costAccepted',
                        spanHeaderHeight: true,
                        cellClass: 'ag-right-aligned-cell',
                        valueFormatter: ({ data, node }) =>
                            formatNumberToRu(
                                node?.rowPinned === 'bottom' ? (data as any)?.costAccepted : data?.totalCost,
                                2,
                            ),
                    },
                ],
            },
        ],
        [],
    );
